import { SchedulesListDataType } from "../../../../../models/list"
import { exportCsvFRM301 } from "./csv"
import { exportExcelFRM301 } from "./excel"

export const exportFRM301 = (data: SchedulesListDataType[]) => {
  exportCsvFRM301(data)
  exportExcelFRM301(data)
}
